<script lang="ts" setup>
import { onMounted } from 'vue'
import { CATEGORY_GAME_SLUG } from '~/resources/lobby-games/urls'
import { LOTTERY_ITEMS } from '~/resources/lobby-games'
import { useLobbyGames } from '~/composables/lobby-games/use-lobby-games'
import { useLode } from '~/composables/lobby-games/use-lode'
import { ModalCollection } from '~/constants'
import { useModal } from '~/composables/common/use-modal'
import FilterDropdown from '~/components/mobile/common/filter-dropdown-v2.vue'
import GameItem from '~/components/common/lobby-games/game-item.vue'
import Modal from '~/components/common/modal.vue'
import NextLotteryItem from '~/components/desktop/pages/lobby-games/next-lottery-item.vue'
import Skeleton from '~/components/common/skeleton.vue'
import Lode from '~/components/mobile/pages/lobby-games/section-lode.vue'
import DirectGames from '~/components/mobile/pages/lobby-games/direct-games.vue'
import SearchForm from '~/components/common/search-form.vue'
import { useGames } from '~/composables/games/use-games'

const { resetNumberDaily, luckyNumber } = useLode()
const { openModal } = useModal()
const modalLotteryId = 'modalLottery'
const { playGame } = useGames()

const {
  isLoadingGame,
  gameType,
  lobbyGames,
  totalPost,
  loadMore,
  fetchGames,
  updateProvidersFilter,
  providerOptions,
  gamePayload
} = useLobbyGames()

useAsyncData('lobby-games-mb', async () => {
  const result = await fetchGames(gamePayload.value)
  lobbyGames.value = result.games
  return result
})

onMounted(() => {
  resetNumberDaily()
})
</script>
<template>
  <div class="lobby-games">
    <!-- Tab lode -->
    <div v-if="gameType === CATEGORY_GAME_SLUG.LODE" class="lo-de">
      <div class="lobby-games__list row row-12px">
        <template v-if="isLoadingGame">
          <div v-for="index in 3" :key="index" class="col-4">
            <Skeleton height="198px" />
          </div>
        </template>
        <template v-else>
          <div v-for="item in lobbyGames" :key="item.ID" class="col-4">
            <GameItem :item="item" :hasSub="false" isMobile :gameType="gameType" :hideGameName="true" />
          </div>
        </template>
        <div class="lo-de__lucky-number">
          <NuxtImg
            format="webp"
            src="/assets/images/mobile/home/mb-lucky-number-banner.png"
            loading="lazy"
            alt="banner lucky"
            densities="1x"
          />
          <div class="lucky-number d-flex align-items-center justify-content-between">
            <div class="lucky-number-note">
              <div class="lucky-number__number">
                <span>{{ luckyNumber }}</span>
              </div>
              <div class="lucky-number__detail">Là số may mắn hôm nay</div>
            </div>
            <div class="lucky-number__action cursor-pointer" @click="lobbyGames.length && playGame(lobbyGames[0])">
              Đánh Số Ngay
            </div>
          </div>
        </div>
        <div class="lo-de__lottery">
          <div class="lottery-title d-flex align-items-center justify-content-between">
            <div class="lottery-title__title">XỔ SỐ 3 MIỀN</div>
            <div class="lottery-title__label d-flex align-items-center" @click="openModal(modalLotteryId)">
              <span>Xem kết quả</span>
            </div>
          </div>
          <div class="lottery-items">
            <div v-for="(item, index) in LOTTERY_ITEMS" :key="index">
              <NextLotteryItem :item="item" />
            </div>
          </div>
        </div>
      </div>

      <Modal
        :modalId="modalLotteryId"
        modalContentClasses="modal-fullscreen modal-fullscreen__lode-container"
        modalBodyClasses="fullscreen__body fullscreen__body--lode"
        modalHeaderClasses="fullscreen__lode-header"
        isFullHeader
        isFullScreen
        headerTitle="Kết quả xổ số"
      >
        <div class="modal-lode">
          <Lode :listGame="lobbyGames" />
        </div>
      </Modal>
    </div>

    <template v-else>
      <div class="lobby-games__filter">
        <FilterDropdown
          label="Nhà cung cấp"
          isLabelFloating
          iconTypeImage
          :valueSelected="gamePayload.prov"
          :modalId="ModalCollection.FILTER_DROPDOWN_MODAL"
          :optionItems="providerOptions"
          @handleItemSelected="updateProvidersFilter"
        />
        <SearchForm v-model="gamePayload.search" />
      </div>
      <div class="lobby-games__wrapper">
        <DirectGames
          :lobbyGames="lobbyGames"
          :totalPost="totalPost"
          :isLoadingGame="isLoadingGame"
          :keywordSearch="gamePayload.search"
          @loadMore="loadMore()"
        />
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/pages/lobby-games/index.scss';
</style>
